import {
  DeleteAccountResult,
  DeleteAccountRepository,
} from '@domain/model/Account/DeleteAccount/DeleteAccountRepository';

const DeleteAccount = (repository: DeleteAccountRepository) => (): Promise<DeleteAccountResult> =>
  repository.deleteAccount();

export {DeleteAccount};
